import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { messages } from "@api/channels/messages/path";

const pathBase = `/channels/`;
const pathById = `${pathBase}/:channelId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const channels = {
  getAll: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  messages,
} as const;
